// ───────── Cascadia Quick View (Desktop) ─────────
// Extracted from theme.js so Motion's core file stays untouched.
// Listens for 'cascadia:qv-loaded', dispatched by theme.js once the QV
// modal markup has been injected into the DOM and Motion's Modal/
// collapsibles/video setup has already run.

(function(){
  if (window.cascadiaQVDesktopBound) return;
  window.cascadiaQVDesktopBound = true;

  document.addEventListener('cascadia:qv-loaded', function(evt){
    var handle = evt.detail.handle;
    var productId = evt.detail.productId;
    var holder = document.getElementById('QuickShopHolder-' + handle);
    if (!holder) return;

    enhanceQV(holder, productId);
  });

  function enhanceQV(holder, productId){

    var qvEl = holder.querySelector('.cascadia-qv');
    var infoEl = holder.querySelector('.cascadia-qv__info');
    var scrollEl = holder.querySelector('.cascadia-qv__scrollable');
    holder.style.setProperty('height', '100%', 'important');
    holder.style.setProperty('display', 'block', 'important');
    if (qvEl) { qvEl.style.setProperty('height', '100%', 'important'); qvEl.style.setProperty('overflow', 'hidden', 'important'); }
    if (infoEl) { infoEl.style.setProperty('height', '100%', 'important'); infoEl.style.setProperty('overflow', 'hidden', 'important'); infoEl.style.setProperty('display', 'flex', 'important'); infoEl.style.setProperty('flex-direction', 'column', 'important'); }
    if (scrollEl) { scrollEl.style.setProperty('flex', '1', 'important'); scrollEl.style.setProperty('overflow-y', 'auto', 'important'); scrollEl.style.setProperty('min-height', '0', 'important'); scrollEl.style.setProperty('max-height', '100%', 'important'); }

    var tabBlocks = Array.from(holder.querySelectorAll('.product-block--tab-colored'));
    if (tabBlocks.length && !holder.querySelector('.seg-tabs')) {
      var icons = { 'skin': '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="5.5" stroke="currentColor" stroke-width="1.2"/><circle cx="8" cy="8" r="2" fill="currentColor"/></svg>', 'leaf': '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M4 12S3 6 8 3c5 3 4 9 4 9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><path d="M4 12c2-2 4-3 8-6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>', 'clock': '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="5.5" stroke="currentColor" stroke-width="1.2"/><path d="M8 4v4l2.5 2.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>', 'routine': '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M2 8a6 6 0 0112 0" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><path d="M14 8a6 6 0 01-12 0" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><path d="M10.5 5.5l-3 3-2-2" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' };
      var wrapper = document.createElement('div');
      wrapper.className = 'seg-tabs';
      tabBlocks[0].parentNode.insertBefore(wrapper, tabBlocks[0]);
      var bar = document.createElement('div');
      bar.className = 'seg-tabs__bar';
      bar.setAttribute('role', 'tablist');
      wrapper.appendChild(bar);
      var slider = document.createElement('div');
      slider.className = 'seg-tabs__slider';
      bar.appendChild(slider);
      var contentArea = document.createElement('div');
      contentArea.className = 'seg-tabs__content';
      wrapper.appendChild(contentArea);
      var segments = [], panels = [];
      tabBlocks.forEach(function(block, i) {
        var title = block.getAttribute('data-pill-title');
        var iconKey = block.getAttribute('data-pill-icon');
        var inner = block.querySelector('.collapsible-content__inner');
        var contentHTML = inner ? inner.innerHTML : '';
        var seg = document.createElement('button');
        seg.className = 'seg-tabs__segment';
        seg.type = 'button';
        seg.setAttribute('role', 'tab');
        seg.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        seg.setAttribute('data-index', i);
        seg.innerHTML = (icons[iconKey] || '') + '<span>' + title + '</span>';
        bar.appendChild(seg);
        segments.push(seg);
        var panel = document.createElement('div');
        panel.className = 'seg-tabs__panel';
        panel.setAttribute('role', 'tabpanel');
        panel.innerHTML = contentHTML;
        panel.style.display = 'none';
        contentArea.appendChild(panel);
        panels.push(panel);
        block.style.display = 'none';
      });
      function moveSlider(i) { var s = segments[i]; if (!s) return; slider.style.left = s.offsetLeft + 'px'; slider.style.width = s.offsetWidth + 'px'; }
      function activate(i) {
        segments.forEach(function(s, j) { s.classList.toggle('is-active', j === i); s.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        panels.forEach(function(p, j) { p.style.display = j === i ? 'block' : 'none'; });
        moveSlider(i);
      }
      segments.forEach(function(seg) { seg.addEventListener('click', function() { activate(parseInt(this.getAttribute('data-index'))); }); });
      setTimeout(function() { activate(0); }, 50);
      document.addEventListener('modalOpen.' + 'QuickShopModal-' + productId, function() {
        setTimeout(function() { moveSlider(0); }, 50);
      }, { once: true });
    }

    setTimeout(function() {
      var skinColors = {
        'all skin types': { bg: '#f0ece7', color: '#3d2314' },
        'normal':         { bg: '#e8f0e8', color: '#1e3a20' },
        'oily':           { bg: '#e8eef5', color: '#1e2e4a' },
        'combination':    { bg: '#f5ece8', color: '#4a2a1e' },
        'dry':            { bg: '#fdf5e8', color: '#4a3a1e' },
        'sensitive':      { bg: '#f5e8f0', color: '#4a1e3a' }
      };
      holder.querySelectorAll('.seg-tabs__panel ul li').forEach(function(li) {
        var key = li.textContent.trim().toLowerCase();
        var match = Object.keys(skinColors).find(function(k) { return key.indexOf(k) > -1; });
        if (match) {
          var style = skinColors[match];
          li.style.setProperty('background', style.bg, 'important');
          li.style.setProperty('color', style.color, 'important');
        }
      });
    }, 100);

    setTimeout(function() {
      holder.querySelectorAll('.seg-tabs__segment').forEach(function(seg, i) {
        if (seg.textContent.toLowerCase().indexOf('how to use') === -1) return;
        var panels = holder.querySelectorAll('.seg-tabs__panel');
        var panel = panels[i];
        if (!panel || panel.dataset.formatted) return;
        var rawText = panel.textContent.trim();
        if (!rawText) return;
        var instructionsText = rawText;
        var goodToKnow = '';
        var storage = '';
        if (rawText.indexOf('Good to know:') > -1) {
          var gtkSplit = rawText.split('Good to know:');
          instructionsText = gtkSplit[0].trim();
          var remainder = gtkSplit[1].trim();
          if (remainder.indexOf('Storage Tip:') > -1 || remainder.indexOf('Storage tip:') > -1) {
            var stSplit = remainder.split(/Storage [Tt]ip:/);
            goodToKnow = stSplit[0].trim();
            storage = stSplit[1].trim();
          } else {
            goodToKnow = remainder;
          }
        } else if (rawText.indexOf('Storage Tip:') > -1 || rawText.indexOf('Storage tip:') > -1) {
          var stSplit = rawText.split(/Storage [Tt]ip:/);
          instructionsText = stSplit[0].trim();
          storage = stSplit[1].trim();
        }
        var hasSteps = /\d+\.\s/.test(instructionsText);
        var stepsHTML = '';
        if (hasSteps) {
          var steps = instructionsText.split(/(?=\d+\.\s)/).filter(function(s) { return s.trim(); });
          stepsHTML += '<div style="display:flex; flex-direction:column; gap:12px;">';
          steps.forEach(function(step) {
            var match = step.match(/^(\d+)\.\s*(.*)/);
            if (match) {
              stepsHTML += '<div style="display:flex; gap:12px; align-items:flex-start;">';
              stepsHTML += '<div aria-hidden="true" style="width:28px; height:28px; border-radius:50%; background:#f0ece7; display:flex; align-items:center; justify-content:center; flex-shrink:0; font-size:12px; font-weight:600; color:#3d2314;">' + match[1] + '</div>';
              stepsHTML += '<p style="font-size:14px; color:#3d2314; line-height:1.5; margin:0; padding-top:4px;">' + match[2].trim() + '</p>';
              stepsHTML += '</div>';
            }
          });
          stepsHTML += '</div>';
        } else {
          stepsHTML = '<p style="font-size:14px; color:#3d2314; line-height:1.7; margin:0;">' + instructionsText.replace(/\n/g, '<br>') + '</p>';
        }
        var infoHTML = '';
        if (goodToKnow || storage) {
          infoHTML += '<div style="display:flex; gap:10px; margin-top:18px;">';
          if (goodToKnow) {
            infoHTML += '<div style="flex:1; background:#faf8f5; border-radius:10px; padding:12px 14px;">';
            infoHTML += '<div style="display:flex; align-items:center; gap:5px; margin-bottom:4px;">';
            infoHTML += '<svg aria-hidden="true" width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M8 1C4.13 1 1 4.13 1 8s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm0 3a1 1 0 110 2 1 1 0 010-2zm2 8H6v-1h1.5V8H6V7h2.5v4H10v1z" fill="#d4a456"/></svg>';
            infoHTML += '<span style="font-size:12px; font-weight:600; color:#8b6914;">Good to know</span></div>';
            infoHTML += '<p style="font-size:12px; color:#6b5c4a; line-height:1.5; margin:0;">' + goodToKnow + '</p></div>';
          }
          if (storage) {
            infoHTML += '<div style="flex:1; background:#faf8f5; border-radius:10px; padding:12px 14px;">';
            infoHTML += '<div style="display:flex; align-items:center; gap:5px; margin-bottom:4px;">';
            infoHTML += '<svg aria-hidden="true" width="12" height="12" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6" stroke="#03593A" stroke-width="1.5" fill="none"/><path d="M8 4v4l2.5 2.5" stroke="#03593A" stroke-width="1.5" stroke-linecap="round"/></svg>';
            infoHTML += '<span style="font-size:12px; font-weight:600; color:#03593A;">Storage</span></div>';
            infoHTML += '<p style="font-size:12px; color:#6b5c4a; line-height:1.5; margin:0;">' + storage + '</p></div>';
          }
          infoHTML += '</div>';
        }
        panel.innerHTML = stepsHTML + infoHTML;
        panel.dataset.formatted = 'true';
      });
    }, 100);

    var segTabsEl = holder.querySelector('.seg-tabs');
    if (segTabsEl && scrollEl) {
      segTabsEl.addEventListener('mouseenter', function() {
        scrollEl.style.overflowY = 'hidden';
      });
      segTabsEl.addEventListener('mouseleave', function() {
        scrollEl.style.overflowY = 'auto';
      });
    }

    // Cascadia QV: variant picker + ajax ATC
    (function() {
      var dataEl = holder.querySelector('[id^="cascadia-qv-data-"]');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch(e) { return; }

      var variants = data.variants;
      var options = data.options;
      var colors = data.scentColors || {};
      var scentNames = data.scentNames || {};
      function scentLabel(optIdx, val) { return (optIdx === 0 && scentNames[val]) || val; }
      var form = holder.querySelector('#qv-form-' + data.productId);
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var priceEl = holder.querySelector('[data-product-price]');
      var atcBtn = holder.querySelector('.cascadia-qv__atc-btn');

      var currentVariant = variants.find(function(v) { return v.available; }) || variants[0];
      var selectedOptions = currentVariant ? currentVariant.options.slice() : [];

      function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function findVariant(opts) {
        return variants.find(function(v) {
          return v.options.every(function(o, i) { return o === opts[i]; });
        });
      }

      function detectType(optionName, values) {
        var name = optionName.toLowerCase();
        var isScent = name === 'scent' || name === 'mood' || name === 'colour' || name === 'color' || name === 'essential oil';
        var isSize = name === 'size' || name === 'volume' || name === 'weight' || name === 'pack';
        var hasScentColors = values.some(function(v) { return colors[v]; });
        if (isScent && hasScentColors) return 1;
        if (isSize) return 2;
        if (values.length === 2) return 2;
        return 4;
      }

      function splitSizeValue(val) {
        var trimmed = (val || '').trim();
        if (/^\d/.test(trimmed)) return { name: trimmed, spec: null };
        var m = trimmed.match(/^(.+?)\s+([\d.]+\s?[a-zA-Z.]+)$/);
        if (m) return { name: m[1].trim(), spec: m[2].trim() };
        return { name: trimmed, spec: null };
      }

      function parseWeight(spec) {
        if (!spec) return null;
        var m = spec.match(/([\d.]+)/);
        return m ? parseFloat(m[1]) : null;
      }

      function updateVariant() {
        var v = findVariant(selectedOptions);
        if (!v) {
          if (idInput) idInput.value = '';
          if (atcBtn) {
            atcBtn.disabled = true;
            atcBtn.style.setProperty('background', '#e8e5e0', 'important');
            atcBtn.style.setProperty('color', '#8a7e6e', 'important');
            atcBtn.style.setProperty('cursor', 'not-allowed', 'important');
            atcBtn.textContent = 'Sold out';
          }
          updateAvailability();
          return;
        }
        currentVariant = v;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (v.featured_image) {
          var firstImg = holder.querySelector('.cascadia-qv__img-frame img');
          if (firstImg) firstImg.src = v.featured_image;
        }
        if (atcBtn) {
          atcBtn.disabled = !v.available;
          atcBtn.style.setProperty('background', v.available ? '#03593A' : '#e8e5e0', 'important');
          atcBtn.style.setProperty('color', v.available ? '#faf8f5' : '#8a7e6e', 'important');
          atcBtn.style.setProperty('cursor', v.available ? 'pointer' : 'not-allowed', 'important');
          var qtyEl = holder.querySelector('.cascadia-qv__qty-input');
          var currentQty = qtyEl ? parseInt(qtyEl.value) || 1 : 1;
          atcBtn.textContent = v.available ? (currentQty > 1 ? 'Add ' + currentQty + ' · ' + formatMoney(v.price * currentQty) : 'Add to cart · ' + formatMoney(v.price)) : 'Sold out';
        }
        updateAvailability();
      }

      function updateAvailability() {
        var pickers = holder.querySelectorAll('.qv-cv-picker');
        if (pickers.length < 2) return;
        var selections = [];
        pickers.forEach(function(picker) {
          var sel = picker.querySelector('.is-selected');
          selections.push(sel ? sel.getAttribute('data-value') : null);
        });
        pickers.forEach(function(picker, pickerIndex) {
          picker.querySelectorAll('[data-value]').forEach(function(item) {
            var testValue = item.getAttribute('data-value');
            var testSelections = selections.slice();
            testSelections[pickerIndex] = testValue;
            var hasMatch = variants.some(function(v) {
              return testSelections.every(function(sel, i) {
                if (sel === null) return true;
                return v.options[i] === sel;
              });
            });
            var isAvailable = variants.some(function(v) {
              var matches = testSelections.every(function(sel, i) {
                if (sel === null) return true;
                return v.options[i] === sel;
              });
              return matches && v.available !== false;
            });
            if (!hasMatch) {
              item.style.opacity = '0.35';
              item.classList.add('cv-unavailable');
            } else if (!isAvailable) {
              item.style.opacity = '0.45';
              item.classList.add('cv-unavailable');
            } else {
              item.style.opacity = '1';
              item.classList.remove('cv-unavailable');
            }
          });
        });
      }

      // Build pickers
      var segTabs = holder.querySelector('.seg-tabs');
      var pickerAnchor = holder.querySelector('.cascadia-qv__picker-anchor');
      var insertBefore = pickerAnchor || segTabs || holder.querySelector('.cascadia-qv__atc-bar');

      if (options.length === 1 && options[0].name === 'Title' && options[0].values[0] === 'Default Title') options = [];

      // global scent-name -> hex fallback — covers bundle components whose option
      // values are pure scent names, since a bundle variant has no single "the scent"
      var globalScentColors = {};
      if (window.cascadiaConfig && window.cascadiaConfig.sampleScents) {
        window.cascadiaConfig.sampleScents.forEach(function(s) {
          if (s.name && s.hex) globalScentColors[s.name.toLowerCase()] = s.hex;
        });
      }
      function colorFor(val) {
        return colors[val] || globalScentColors[(val || '').toLowerCase()] || '#c8b89a';
      }
      var componentOverrides = data.componentScentOverrides || {};
      var FALLBACK_TAN = '#d4c5b0';
      function globalColorForComponent(label, val) {
        var overrideKey = (label + '|' + val).toLowerCase();
        var realScentName = componentOverrides[overrideKey] || val;
        var fromGlobal = globalScentColors[(realScentName || '').toLowerCase()];
        if (fromGlobal) return fromGlobal;
        var fromProduct = colors[val];
        if (fromProduct && fromProduct !== FALLBACK_TAN) return fromProduct;
        return '#c8b89a';
      }

      function capitalizeFirst(str) {
        str = str || '';
        return str.charAt(0).toUpperCase() + str.slice(1);
      }

      // detect component-scoped attribute options — covers both "Component - Scent"
      // and "Component (Scent)" / "Component (Concentration)" naming styles used
      // across different bundle/set products, and strips extra modifiers like "(Vegan)"
      function detectComponentOption(name) {
        var m = name.match(/(?:-\s*|\()\s*(scent|concentration)\s*\)?\s*$/i);
        if (!m) return null;
        var attr = m[1].toLowerCase();
        var label = name.slice(0, m.index).trim();
        label = label.replace(/\s*\([^)]*\)\s*$/g, '').trim();
        return { attr: attr, label: capitalizeFirst(label) };
      }

      var componentOptions = [];
      options.forEach(function(opt, optIdx) {
        var det = detectComponentOption(opt.name);
        if (det) componentOptions.push({ opt: opt, optIdx: optIdx, label: det.label, attr: det.attr });
      });

      function buildComponentPicker(components) {
        var wrap = document.createElement('div');
        wrap.className = 'qv-bundle-scents';

        var summary = document.createElement('div');
        summary.className = 'qv-bundle-scents__summary';
        var dotsPreview = document.createElement('div');
        dotsPreview.className = 'qv-bundle-scents__preview';
        components.forEach(function(c) {
          var val = selectedOptions[c.optIdx] || c.opt.values[0];
          var d = document.createElement('span');
          d.className = 'qv-bundle-scents__preview-dot';
          d.style.background = c.attr === 'scent' ? globalColorForComponent(c.label, val) : '#c8a24e';
          dotsPreview.appendChild(d);
        });
        var summaryText = document.createElement('span');
        summaryText.className = 'qv-bundle-scents__summary-text';
        summaryText.textContent = 'Customize your set';
        var summaryLeft = document.createElement('div');
        summaryLeft.className = 'qv-bundle-scents__summary-left';
        summaryLeft.appendChild(summaryText);
        summaryLeft.appendChild(dotsPreview);

        var toggle = document.createElement('span');
        toggle.className = 'qv-bundle-scents__toggle';
        toggle.innerHTML = '<svg width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        summary.appendChild(summaryLeft);
        summary.appendChild(toggle);

        var rows = document.createElement('div');
        rows.className = 'qv-bundle-scents__rows';

        components.forEach(function(c) {
          var currentVal = selectedOptions[c.optIdx] || c.opt.values[0];
          var row = document.createElement('div');
          row.className = 'qv-bundle-scents__row';

          var name = document.createElement('span');
          name.className = 'qv-bundle-scents__row-name';
          name.textContent = c.label;
          row.appendChild(name);

          var dotsWrap = document.createElement('div');
          dotsWrap.className = 'qv-bundle-scents__row-dots';
          var labelOut = document.createElement('span');
          labelOut.className = 'qv-bundle-scents__row-label';
          labelOut.textContent = currentVal;

          c.opt.values.forEach(function(val) {
            var el = document.createElement('span');
            if (c.attr === 'scent') {
              el.className = 'qv-bundle-scents__dot' + (val === currentVal ? ' is-selected' : '');
              el.style.background = globalColorForComponent(c.label, val);
            } else {
              el.className = 'qv-bundle-scents__chip' + (val === currentVal ? ' is-selected' : '');
              el.textContent = val;
            }
            el.setAttribute('role', 'radio');
            el.setAttribute('aria-checked', val === currentVal ? 'true' : 'false');
            el.setAttribute('aria-label', c.label + ': ' + val);
            el.setAttribute('tabindex', '0');
            el.addEventListener('click', function() {
              dotsWrap.querySelectorAll('.qv-bundle-scents__dot, .qv-bundle-scents__chip').forEach(function(d) {
                d.classList.remove('is-selected');
                d.setAttribute('aria-checked', 'false');
              });
              el.classList.add('is-selected');
              el.setAttribute('aria-checked', 'true');
              labelOut.textContent = val;
              selectedOptions[c.optIdx] = val;
              updateVariant();
            });
            el.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); } });
            dotsWrap.appendChild(el);
          });
          dotsWrap.appendChild(labelOut);
          row.appendChild(dotsWrap);
          rows.appendChild(row);
        });

        summary.addEventListener('click', function() {
          wrap.classList.add('is-open');
        });

        wrap.appendChild(summary);
        wrap.appendChild(rows);
        insertBefore.parentNode.insertBefore(wrap, insertBefore);
      }

      options.forEach(function(opt, optIdx) {
        var det = detectComponentOption(opt.name);
        if (det && componentOptions.length >= 2) return; // rendered together below

        var displayName = det ? det.label : capitalizeFirst(opt.name);
        var values = opt.values;
        var type = det ? (det.attr === 'scent' ? 1 : 2) : detectType(opt.name, values);
        var currentVal = selectedOptions[optIdx] || values[0];

        var wrapper = document.createElement('div');
        wrapper.className = 'qv-cv-picker cv-picker cv-picker--type' + type;

        var label = document.createElement('p');
        if (type === 2) {
          label.className = 'cv-sz2-eyebrow';
          label.textContent = displayName;
        } else {
          label.className = 'cascadia-qv__picker-label';
          label.innerHTML = displayName + ': <strong>' + (type === 1 ? scentLabel(optIdx, currentVal) : currentVal) + '</strong>';
          label.style.setProperty('font-size', '14px', 'important');
          label.style.setProperty('color', '#3d2314', 'important');
          label.style.setProperty('font-weight', '400', 'important');
          label.style.setProperty('margin', '0 0 10px', 'important');
        }
        wrapper.appendChild(label);

        var body = document.createElement('div');

        if (type === 1) {
          body.className = 'cv-picker__body--dot-grid';
          values.forEach(function(val) {
            var color = colors[val] || '#c8b89a';
            var card = document.createElement('div');
            card.className = 'cv-dot-card' + (val === currentVal ? ' is-selected' : '');
            card.setAttribute('data-value', val);
            card.setAttribute('role', 'radio');
            card.setAttribute('aria-checked', val === currentVal ? 'true' : 'false');
            card.setAttribute('aria-label', scentLabel(optIdx, val));
            card.setAttribute('tabindex', '0');
            card.innerHTML = '<div class="cv-dot" style="background:' + color + ';" aria-hidden="true"></div><div class="cv-dot-name">' + scentLabel(optIdx, val) + '</div>';
            card.addEventListener('click', function() {
              body.querySelectorAll('.cv-dot-card').forEach(function(c) { c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false'); });
              card.classList.add('is-selected');
              card.setAttribute('aria-checked', 'true');
              label.innerHTML = displayName + ': <strong>' + scentLabel(optIdx, val) + '</strong>';
              selectedOptions[optIdx] = val;
              holder.querySelectorAll('.cv-sz-card').forEach(function(szCard) {
                var sizeVal = szCard.getAttribute('data-value');
                var match = variants.find(function(v) { return v.options[0] === val && v.options[1] === sizeVal; });
                if (match) {
                  var priceEl2 = szCard.querySelector('.cv-sz-price');
                  if (priceEl2) priceEl2.textContent = formatMoney(match.price);
                }
              });
              updateVariant();
            });
            card.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); } });
            body.appendChild(card);
          });

        } else if (type === 2) {
          body.className = 'cv-picker__body--sz-grid2';
          body.setAttribute('role', 'radiogroup');
          body.setAttribute('aria-label', opt.name);

          var isConcentrationOption = det
            ? det.attr === 'concentration'
            : /concentration/i.test(opt.name);

          var splits = values.map(function(val) { return splitSizeValue(val); });
          var weights = splits.map(function(s) { return parseWeight(s.spec); });
          var validWeights = weights.filter(function(w) { return w !== null; });
          var maxWeight = validWeights.length ? Math.max.apply(null, validWeights) : null;
          var MIN_DOT = 9, MAX_DOT = 16, FALLBACK_DOT = 12;
          function dotSizeFor(w) {
            if (w === null || !maxWeight) return FALLBACK_DOT;
            return Math.round(MIN_DOT + (w / maxWeight) * (MAX_DOT - MIN_DOT));
          }

          values.forEach(function(val, i) {
            var matchVariant = variants.find(function(v) { return v.options.indexOf(val) > -1; });
            var price = matchVariant ? matchVariant.price : null;
            var isBest = matchVariant ? !!matchVariant.bestValue : false;
            var split = splits[i];
            var dotPx = dotSizeFor(weights[i]);
            var isSelected = val === currentVal;

            var card = document.createElement('div');
            card.className = 'cv-sz2-card' + (isSelected ? ' is-selected' : '');
            card.setAttribute('data-value', val);
            card.setAttribute('role', 'radio');
            card.setAttribute('aria-checked', isSelected ? 'true' : 'false');
            card.setAttribute('tabindex', '0');

            var dotStyle = 'width:' + dotPx + 'px;height:' + dotPx + 'px;';
            var innerDot = isSelected ? '<span style="width:' + Math.round(dotPx * 0.33) + 'px;height:' + Math.round(dotPx * 0.33) + 'px;"></span>' : '';
            var html = '<span class="cv-sz2-dot' + (isSelected ? ' is-on' : '') + '" style="' + dotStyle + '">' + innerDot + '</span>';
            html += '<span class="cv-sz2-name">' + split.name + '</span>';
            if (split.spec) html += '<span class="cv-sz2-spec">' + split.spec + '</span>';
            if (price && !isConcentrationOption) html += '<span class="cv-sz2-price">' + formatMoney(price) + '</span>';
            if (isBest) html += '<span class="cv-sz2-best">Best value</span>';
            card.innerHTML = html;

            card.addEventListener('click', function() {
              body.querySelectorAll('.cv-sz2-card').forEach(function(c) {
                c.classList.remove('is-selected');
                c.setAttribute('aria-checked', 'false');
                var d = c.querySelector('.cv-sz2-dot');
                d.classList.remove('is-on');
                d.innerHTML = '';
              });
              card.classList.add('is-selected');
              card.setAttribute('aria-checked', 'true');
              var dot = card.querySelector('.cv-sz2-dot');
              dot.classList.add('is-on');
              var dSize = parseInt(dot.style.width, 10);
              dot.innerHTML = '<span style="width:' + Math.round(dSize * 0.33) + 'px;height:' + Math.round(dSize * 0.33) + 'px;"></span>';
              selectedOptions[optIdx] = val;
              updateVariant();
            });
            card.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); } });
            body.appendChild(card);
          });

        } else if (type === 3) {
          body.className = 'cv-picker__body--pill-pair';
          values.forEach(function(val) {
            var matchVariant = variants.find(function(v) { return v.options.indexOf(val) > -1; });
            var price = matchVariant ? matchVariant.price : null;
            var pill = document.createElement('div');
            pill.className = 'cv-sz-pill' + (val === currentVal ? ' is-selected' : '');
            pill.setAttribute('data-value', val);
            pill.setAttribute('role', 'radio');
            pill.setAttribute('aria-checked', val === currentVal ? 'true' : 'false');
            pill.setAttribute('tabindex', '0');
            var html = '<span class="cv-pill-name">' + val + '</span>';
            if (price) html += '<span class="cv-pill-price">' + formatMoney(price) + '</span>';
            pill.innerHTML = html;
            pill.addEventListener('click', function() {
              body.querySelectorAll('.cv-sz-pill').forEach(function(p) { p.classList.remove('is-selected'); p.setAttribute('aria-checked', 'false'); });
              pill.classList.add('is-selected');
              pill.setAttribute('aria-checked', 'true');
              label.innerHTML = opt.name + ': <strong>' + val + '</strong>';
              selectedOptions[optIdx] = val;
              updateVariant();
            });
            pill.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pill.click(); } });
            body.appendChild(pill);
          });

        } else {
          body.className = 'cv-picker__body--plain-grid';
          values.forEach(function(val) {
            var pill = document.createElement('div');
            pill.className = 'cv-plain-pill' + (val === currentVal ? ' is-selected' : '');
            pill.setAttribute('data-value', val);
            pill.setAttribute('role', 'radio');
            pill.setAttribute('aria-checked', val === currentVal ? 'true' : 'false');
            pill.setAttribute('tabindex', '0');
            pill.textContent = val;
            pill.addEventListener('click', function() {
              body.querySelectorAll('.cv-plain-pill').forEach(function(p) { p.classList.remove('is-selected'); p.setAttribute('aria-checked', 'false'); });
              pill.classList.add('is-selected');
              pill.setAttribute('aria-checked', 'true');
              label.innerHTML = opt.name + ': <strong>' + val + '</strong>';
              selectedOptions[optIdx] = val;
              updateVariant();
            });
            pill.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pill.click(); } });
            body.appendChild(pill);
          });
        }

        wrapper.appendChild(body);
        insertBefore.parentNode.insertBefore(wrapper, insertBefore);
      });

      if (componentOptions.length >= 2) {
        buildComponentPicker(componentOptions);
      }

      if (form) {
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          var atcBtn = holder.querySelector('.cascadia-qv__atc-btn');
          if (!currentVariant || !currentVariant.available) return;
          var qtyInput = holder.querySelector('.cascadia-qv__qty-input');
          var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
          atcBtn.disabled = true;
          atcBtn.textContent = 'Adding…';
          atcBtn.style.setProperty('background', '#03593A', 'important');

          window.cascadiaState.addToCart(currentVariant.id, qty)
            .then(function(result) {
              if (result && result.status === 422) {
                atcBtn.disabled = false;
                atcBtn.textContent = result.description || 'Try again';
                atcBtn.style.setProperty('background', '#e8e5e0', 'important');
                setTimeout(function() {
                  atcBtn.textContent = qty > 1 ? 'Add ' + qty + ' · ' + formatMoney(currentVariant.price * qty) : 'Add to cart · ' + formatMoney(currentVariant.price);
                  atcBtn.style.setProperty('background', '#03593A', 'important');
                }, 2000);
                return;
              }
              atcBtn.textContent = '✓ Added';
              atcBtn.style.setProperty('background', '#1e3a20', 'important');
              atcBtn.disabled = false;
              setTimeout(function() {
                atcBtn.disabled = false;
                atcBtn.textContent = qty > 1 ? 'Add ' + qty + ' · ' + formatMoney(currentVariant.price * qty) : 'Add to cart · ' + formatMoney(currentVariant.price);
                atcBtn.style.setProperty('background', '#03593A', 'important');
              }, 2000);
            })
            .catch(function() {
              atcBtn.disabled = false;
              atcBtn.textContent = 'Try again';
              setTimeout(function() {
                atcBtn.textContent = qty > 1 ? 'Add ' + qty + ' · ' + formatMoney(currentVariant.price * qty) : 'Add to cart · ' + formatMoney(currentVariant.price);
              }, 2000);
            });
        });
      }

      updateVariant();

      var qtyInputEl = holder.querySelector('.cascadia-qv__qty-input');
      if (qtyInputEl) {
        var qtyNumEl = holder.querySelector('.cascadia-qv__qty-num');
        var observer = new MutationObserver(function() {
          var q = parseInt(qtyInputEl.value) || 1;
          var atcB = holder.querySelector('.cascadia-qv__atc-btn');
          if (atcB && !atcB.disabled && currentVariant && currentVariant.available) {
            var total = formatMoney(currentVariant.price * q);
            atcB.textContent = q > 1 ? 'Add ' + q + ' · ' + total : 'Add to cart · ' + formatMoney(currentVariant.price);
          }
        });
        observer.observe(qtyInputEl, { attributes: true, attributeFilter: ['value'] });
        if (qtyNumEl) {
          observer.observe(qtyNumEl, { childList: true, subtree: true, characterData: true });
        }
      }

    })();

  }

})();